import { composeIO } from 'react-compose-io'
import { resumoItemIO } from './ResumoItem.IO'
import { ResumoItemView } from './ResumoItem.View'

export const ResumoItem = composeIO(ResumoItemView, resumoItemIO)
